import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {Spinner, SpinnerSize} from "office-ui-fabric-react";
import React = require("react");
import {FilingLocation, PaginatedFilingLocations} from "../models";
import {ApiCallState} from "./ApiCallState";
import {LocationItemsListTabView} from "./LocationItemsListTabView";

export interface ExternalTeamChannelsState extends ITeamsBaseComponentState {}

export interface ExternalTeamChannelsProps {
    externalTeamName: string;
    externalTeamNameRetrievalState: ApiCallState;
    externalChannels: PaginatedFilingLocations;
    externalChannelsRetrievalState: ApiCallState;
    searchFilter: string;
    teamsId: string;
    channelId: string;
    storageType: string;
    userId: string;
    tenantId: string;
    isDarkMode: boolean;
    isClientCollabLicensed: boolean;
    onChooseLocation: (location: FilingLocation) => Promise<void>;
    showFilingButton: (value: boolean, location: FilingLocation) => void;
}

export class ExternalTeamChannelsSharing extends TeamsBaseComponent<
    ExternalTeamChannelsProps,
    ExternalTeamChannelsState
> {
    constructor(props: ExternalTeamChannelsProps) {
        super(props);
    }

    public render() {
        const loadingText = this.getLoadingText();

        return (
            <div>
                {loadingText && <Spinner size={SpinnerSize.medium} label={loadingText} />}

                {this.props.externalTeamNameRetrievalState == ApiCallState.Error && (
                    <p style={{fontSize: "16px", color: "red"}}>External Team Name Retrieval Failed.</p>
                )}

                {this.props.externalTeamNameRetrievalState == ApiCallState.Success && (
                    <p style={{fontSize: "16px"}}>
                        {this.props.externalTeamName} {">"} Channels
                    </p>
                )}

                {this.props.externalChannelsRetrievalState == ApiCallState.Error && (
                    <p style={{fontSize: "16px", color: "red"}}>External Team Channels Retrieval Failed.</p>
                )}

                {this.props.externalChannelsRetrievalState == ApiCallState.Success && (
                    <LocationItemsListTabView
                        onChooseLocation={this.props.onChooseLocation}
                        chooseThisLocationText={"File Here"}
                        locations={this.props.externalChannels}
                        isSearching={false}
                        onExpand={() => {}}
                        showResults={true}
                        searchPhrase={null}
                        moreResults={false}
                        folderSearch={false}
                        localDocs={false}
                        teamsId={this.props.teamsId}
                        channelId={this.props.channelId}
                        storageType={this.props.storageType}
                        userId={this.props.userId}
                        tenantId={this.props.tenantId}
                        errorMessage={null}
                        TabView={true}
                        ShowCheckinPanel={() => {}}
                        noItemsText="The matter area you are connected to is currently empty"
                        expandedResults={null}
                        onBack={null}
                        darkMode={this.props.isDarkMode}
                        searchFilter={this.props.searchFilter}
                        shouldIncludeCheckedOutFiles={false}
                        checkoutToChannel={true}
                        ShowFilingButton={this.props.showFilingButton}
                        expandedFolderResults={null}
                        setExpandedResults={() => {}}
                        clientCollabLicensed={this.props.isClientCollabLicensed}
                        searchAllDms={false}
                        EllipsisOptionOnClick={() => {}}
                        privateChannel={false}
                        isLitigationHoldEnabled={false} // todo: does this need real value? 
                        isFrictionlessSpExperienceEnabled={false}
                    />
                )}
            </div>
        );
    }

    private getLoadingText() {
        if (
            this.props.externalChannelsRetrievalState == ApiCallState.Loading &&
            this.props.externalTeamNameRetrievalState == ApiCallState.Loading
        ) {
            return "Loading external team...";
        } else if (this.props.externalChannelsRetrievalState == ApiCallState.Loading) {
            return "Loading external team channels...";
        } else if (this.props.externalTeamNameRetrievalState == ApiCallState.Loading) {
            return "Loading external team name...";
        }
        return null;
    }
}
